<app-dialog-container [showKeyboardButton]="false" [showHelpButton]="false">
  <h1 mat-dialog-title>{{ title }}</h1>
  <div mat-dialog-content class="branch-dialog" [formGroup]="form">
    <p class="branch-hint" *ngIf="isMatriz">
      A Matriz acompanha o endereço principal do cliente.
    </p>
    <div class="branch-grid branch-grid-3">
      <app-input [config]="config('branchTitle')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('branchDocument')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('branchStateRegistration')" [group]="form" [typeCes]="fieldType"></app-input>
    </div>
    <div class="branch-grid branch-grid-4">
      <app-input [config]="config('branchCep')" [group]="form" [typeCes]="fieldType" (onChange)="lookupCep()"></app-input>
      <app-input [config]="config('branchAddress')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('branchAddressNumber')" [group]="form" [typeCes]="fieldType"></app-input>
    </div>
    <div class="branch-grid branch-grid-4">
      <app-input [config]="config('branchAddressComplement')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('branchNeighborhood')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('branchCity')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('branchState')" [group]="form" [typeCes]="fieldType"></app-input>
    </div>
    <app-input [config]="config('branchObservation')" [group]="form" [typeCes]="fieldType"></app-input>
  </div>
  <app-dialog-save-close
    *ngIf="!viewMode"
    [closeOnSave]="false"
    closeText="VOLTAR"
    (onSave)="save()">
  </app-dialog-save-close>
  <div *ngIf="viewMode" mat-dialog-actions align="end">
    <button type="button" class="custom-button" mat-raised-button (click)="close()">VOLTAR</button>
  </div>
</app-dialog-container>
